import { render, staticRenderFns } from "./CostPricesUnitDetail.vue?vue&type=template&id=7fdbea17&scoped=true"
import script from "./CostPricesUnitDetail.vue?vue&type=script&lang=js"
export * from "./CostPricesUnitDetail.vue?vue&type=script&lang=js"
import style0 from "./CostPricesUnitDetail.vue?vue&type=style&index=0&id=7fdbea17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdbea17",
  null
  
)

export default component.exports